import { attributes } from './attributes';

export { attributes };

export const e2e = {
  attributes,
};
